// THIS FILE IS GENERATED, DO NOT MODIFY MANUALLY. ##checksum##: 990171299
export default [
  'report-sync-issue',
  'block-app-with-message',
  'new-onboarding-connect-account',
  'premium-upgrade-form-copy-position',
  'copy-balance-history',
  'ai-spending-insights',
  'new-enrichment-pipeline',
  'ab-test-annual-upsell-web',
  'sankey-diagram',
  'ab-test-invite-partner-onboarding',
  'needs-review-by',
  'ab-test-connect-single-account-before-paywall',
  'advisor-onboarding-web',
  'ab-test-cash-flow-sankey-default',
  'ab-test-onboarding-sankey',
  'connect-mx-institutions',
  'connect-finicity-institutions',
  'investment-transactions-enabled',
  'support-chat-bubble',
  'block-signups-with-message',
  'new-download-transactions',
  'filter-menu-other',
  'transactions-ui-v2-web',
  'hide-status-label-apps',
  'liabilities',
  'liabilities-view-more',
  'transactions-ui-updates-walkthrough',
  'account-custom-logos',
  'referral-promo-test-copy-changes',
  'ab-test-goal-oriented-signup',
  'ab-test-fake-experiment',
  'ab-test-credit-card-first',
  'ab-test-remove-app-upsell-and-skip',
  'rebrand-toggle-visible',
  'rebrand-whats-new-post',
  'transfer-account-data',
  'show-advisor-directory-in-product',
  'new-credential-delete-disable-modal',
  'ab-test-pre-registration-survey',
  'referrals-v2',
  'referrals-whats-new-post',
  'command-palette',
] as const;
